/* eslint-disable no-script-url */
import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
// install Swiper modules
SwiperCore.use([Pagination, Autoplay]);

let SwipeItem = () => {
    const [listItems, setListItem] = useState([]);
    useEffect(() => {
        // fetch("/apt/banner/")
        fetch(process.env.REACT_APP_BANNER_API)
            .then(res => res.json())
            .then((result) => {
                setListItem(result);
            })
            .catch(err => {
                throw new Error(err)
            })
    }, [])

    return (
        <Swiper
            spaceBetween={50}
            pagination={{ clickable: true }}
            loop={true}
            autoplay={{
                "delay": 2500,
                "disableOnInteraction": false
            }}  >

            {listItems.map((item, index) => (
                <SwiperSlide key={index}>
                    {/*若無超連結時不需跳轉*/}
                    <a href={item.link===""?"javascript:void(0)":item.link} target={item.link===""?"":"_blank"} rel="noreferrer">
                        <picture>
                            <source srcSet={require("../../" + item.name_moblie).default} type="image/webp" media="(max-width:767px)" />
                            <img src={require("../../" + item.name).default} alt={item.name}/>
                        </picture>
                    </a>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

let Slider = () => {
    return (
        <div className="section banner_index" id="section0">
            <div className="banner">
                {/* <BrowserRouter> */}
                <SwipeItem />
                {/* </BrowserRouter> */}
            </div>
        </div>
    )
}

export default Slider;